import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthService} from '../../common/services/auth.service';
import {Principal} from '../../common/services/principal';
import {Utils} from '../../common/services/Utils';
import {ConfirmDialogComponent} from '../../common/dialogs/confirm-dialag/confirm-dialag.component';
import {PaginationComponent} from './components/pagination/pagination.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from '../../common/config/auth.interceptor';
import {CommonLayoutComponent} from './components/common-layout/common.component';
import {RouterModule} from '@angular/router'; // <-- import the module
import {NotificationService} from './services/notification.service';
import {ButtonComponent} from './components/button/button.component';
import {CommonService} from './services/common.service';
import {EditButtonComponent} from './components/edit-button/edit-button.component';
import {DeleteButtonComponent} from './components/delete-button/delete-button.component';
import {AddButtonComponent} from './components/add-button/add-button.component';
import {FileService} from './services/file.service';
import {ColumnSortComponent} from './components/column-sort/column-sort.component';
import {SafeHtmlPipe} from './pipes/safe-html.pipe';
import {FileSizePipe} from './pipes/file-size-pipe';
import {GraduateRegisterService} from './services/graduate-register.service';
import {DictionaryService} from './services/dictionary.service';
import {OrderModule} from 'ngx-order-pipe';
import {CatoService} from '../user/services/cato.service';
import {EsuvoOptionService} from './services/esuvo-option.service';
import {WebSocketService} from './services/web-socket.service';
import {EdsSignModalComponent} from '../user/components/public-services/eds-sign/eds-sign-modal.component';
import {PublicServicesService} from '../admin/services/public-services.service';
import {EdsService} from 'app/modules/shared/services/eds.service';
import {YesNoPipe} from './pipes/yes-no.pipe';
import {TechSupportService} from './services/tech-support.service';
import {ShareDataService} from './services/share-data.service';
import {CatoComponent} from 'app/modules/user/components/dictionary/cato/cato.component';
import {CenterProfessionComponent} from '../user/components/dictionary/profession/center-profession.component';
import {ProfessionTypeComponent} from '../user/components/dictionary/profession-type/profession-type.component';
import {CenterNationalityComponent} from '../user/components/dictionary/nationality/center-nationality.component';
import {StudyLanguageListComponent} from '../user/components/dictionary/study-language-list/study-language-list.component';
import {CenterProfessionDialogComponent} from '../user/components/dictionary/profession/edit/center-profession-dialog.component';
import {ProfessionTypeDialogComponent} from '../user/components/dictionary/profession-type/edit/profession-type-dialog.component';
import {CenterNationalityDialogComponent} from '../user/components/dictionary/nationality/edit/center-nationality-dialog.component';
import {CenterCollegeComponent} from '../user/components/dictionary/university/center-college.component';
import {EditCenterCollegeComponent} from '../user/components/dictionary/university/edit/edit-center-college.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {UniversityInfoEditComponent} from '../admin/components/public-page/main-menu/university-info-dialog/edit/university-info-edit.component';
import {AppFilter} from './pipes/filter.pipte';
import {AdmissionService} from './services/admission.service';
import {ViewButtonComponent} from './components/view-button/view-button.component';
import {TemplateService} from './services/template.service';
import {DirectionOfSpecialityListComponent} from './components/dictionary/direction-of-speciality-list/direction-of-speciality-list.component';
import {SubjectForAdmissionListComponent} from './components/dictionary/subject-for-admission-list/subject-for-admission-list.component';
import {AdmissionListComponent} from './components/dictionary/admission-list/admission-list.component';
import {DirectionOfSpecialityEditModalComponent} from './components/dictionary/direction-of-speciality-list/direction-of-speciality-edit-modal/direction-of-speciality-edit-modal.component';
import {SubjectForAdmissionModalComponent} from './components/dictionary/subject-for-admission-list/subject-for-admission-modal/subject-for-admission-modal.component';
import {AdmissionEditModalComponent} from './components/dictionary/admission-list/admission-edit-modal/admission-edit-modal.component';
import {ArraysIdsFilterPipe} from './pipes/arrays-ids-filter.pipe';
import {CenterSpecializationListComponent} from '../user/components/dictionary/center-specialization-list/center-specialization-list.component';
import {CenterSpecializationService} from 'app/modules/shared/services/center-specialization.service';
import {CollegeRegionService} from "../common-main/services/college-region.service";
import {PlatonusReleaseService} from './services/platonus-release-service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    HttpClientModule,
    RouterModule,
    OrderModule,
    NgSelectModule
  ],
  declarations: [
    ConfirmDialogComponent,
    PaginationComponent,
    CommonLayoutComponent,
    ButtonComponent,
    EditButtonComponent,
    DeleteButtonComponent,
    AddButtonComponent,
    ColumnSortComponent,
    SafeHtmlPipe,
    FileSizePipe,
    YesNoPipe,
    CatoComponent,
    CenterProfessionComponent,
    ProfessionTypeComponent,
    CenterNationalityComponent,
    StudyLanguageListComponent,
    CenterProfessionDialogComponent,
    ProfessionTypeDialogComponent,
    CenterNationalityDialogComponent,
    CenterCollegeComponent,
    EditCenterCollegeComponent,
    UniversityInfoEditComponent,
    EdsSignModalComponent,
    AppFilter,
    ViewButtonComponent,
    DirectionOfSpecialityEditModalComponent,
    SubjectForAdmissionModalComponent,
    AdmissionEditModalComponent,
    DirectionOfSpecialityListComponent,
    SubjectForAdmissionListComponent,
    AdmissionListComponent,
    CenterSpecializationListComponent,
    ArraysIdsFilterPipe
  ],
  providers: [
    AuthService,
    Principal,
    Utils,
    NotificationService,
    CommonService,
    FileService,
    GraduateRegisterService,
    DictionaryService,
    CatoService,
    EsuvoOptionService,
    WebSocketService,
    PublicServicesService,
    EdsService,
    TechSupportService,
    ShareDataService,
    AdmissionService,
    CollegeRegionService,
    PlatonusReleaseService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    TemplateService,
    CenterSpecializationService
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule,
    PaginationComponent,
    HttpClientModule,
    CommonLayoutComponent,
    ButtonComponent,
    AddButtonComponent,
    EditButtonComponent,
    DeleteButtonComponent,
    ColumnSortComponent,
    SafeHtmlPipe,
    FileSizePipe,
    YesNoPipe,
    OrderModule,
    EdsSignModalComponent,
    AppFilter,
    ViewButtonComponent,
    DirectionOfSpecialityEditModalComponent,
    SubjectForAdmissionModalComponent,
    AdmissionEditModalComponent,
    DirectionOfSpecialityListComponent,
    SubjectForAdmissionListComponent,
    AdmissionListComponent,
    CenterSpecializationListComponent,
    ArraysIdsFilterPipe
  ],
  entryComponents: [
    ConfirmDialogComponent,
    EdsSignModalComponent,
    CenterProfessionDialogComponent,
    ProfessionTypeDialogComponent,
    CenterNationalityDialogComponent,
    UniversityInfoEditComponent,
    DirectionOfSpecialityEditModalComponent,
    SubjectForAdmissionModalComponent,
    AdmissionEditModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts